import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import moment from "moment";

import { findAllByAdmin } from "src/api/quotationDraft";

import device from "src/styles/device";
import { getLocale } from "react-i18nify";
// import font from "src/styles/font";

import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import SearchIcon from "@mui/icons-material/Search";
// import InputLabel from "@mui/material/InputLabel";
// import FormControl from "@mui/material/FormControl";
// import Select from "@mui/material/Select";
// import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";

import VisibilityIcon from "@mui/icons-material/Visibility";
import { useAuth } from "src/hooks/useAuth";

const DivMuiContainer = styled.div`
  width: 100%;
  height: auto;
  padding: 32px;
  border-radius: 32px;
  background-color: #ffffff;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  // display: flex;
  justify-content: center;
  align-items: center;

  @media ${device.tabletL} {
    padding: 0;
    border-radius: 0;
    box-shadow: none;
  }
`;

const DivMuiInside = styled.div`
  width: 100%;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
`;

const WrapperSearch = styled.div`
  // margin-bottom: 32px;
  margin-right: 16px;
  width: 65%;
  position: relative;
  display: flex;
  justify-content: center;

  @media ${device.tabletL} {
    width: 75%;
    /* margin-right: 4px; */
  }
  @media ${device.mobileL} {
    width: 75%;
  }

  .TextField-without-border-radius fieldset {
    border-radius: 16px;
  }
  .MuiTextField-root {
    margin: 0;
  }
`;

// const WrapperSelect = styled.div`
//   width: 15%;
//   position: relative;
//   display: flex;
//   justify-content: center;

//   .TextField-without-border-radius fieldset {
//     border-radius: 16px;
//   }
//   .MuiOutlinedInput-input {
//     padding: 10px 16px;
//   }
//   .MuiInputLabel-root[data-shrink=false] {
//     transform: translate(16px, 10px) scale(1);
//   }

//   .MuiInputLabel-root[data-shrink=true] {
//     transform: translate(16px, -11px) scale(0.75);
//   }
// `;

const WrapperDataGrid = styled.div`
  height: 600px;
  width: 100%;
  background: var(--white-color);

  .MuiDataGrid-root {
    border: 1px solid #ffffff;
  }
  .MuiDataGrid-columnHeaders {
    background-color: #f5f5f5;
  }
  .MuiDataGrid-root .MuiDataGrid-columnSeparator--sideRight {
    color: #f5f5f5;
  }
  .MuiDataGrid-root .MuiDataGrid-columnHeader:focus-within {
    // outline: solid #f5f5f5 1px;
    outline: none;
  }
  .MuiDataGrid-root .MuiDataGrid-cell:focus {
    outline: none;
    border-bottom: solid #f5f5f5 1px 0 1px 0;
  }
  .MuiDataGrid-root .MuiDataGrid-row.Mui-selected {
    background-color: #ffffff;
  }

  @media ${device.tabletL} {
    height: 70dvh;
    border-radius: 24px;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);

    .MuiDataGrid-root {
      border-radius: 24px;
    }
    .MuiDataGrid-columnHeaders {
      border-radius: 24px 24px 0 0;
    }
    .MuiDataGrid-columnHeader:first-child,
    .MuiDataGrid-cell:first-child {
      padding-left: 32px;
    }
    .MuiDataGrid-columnHeader:last-child,
    .MuiDataGrid-cell:last-child {
      padding-right: 32px;
    }
  }
  @media ${device.mobileL} {
    border-radius: 16px;

    .MuiDataGrid-root {
      border-radius: 16px;
    }
    .MuiDataGrid-columnHeaders {
      border-radius: 16px 16px 0 0;
    }
    .MuiDataGrid-columnHeader:first-child,
    .MuiDataGrid-cell:first-child {
      padding-left: 16px;
    }
    .MuiDataGrid-columnHeader:last-child,
    .MuiDataGrid-cell:last-child {
      padding-right: 16px;
    }
  }
`;

const ImageNoData = styled.image`
  width: 120px;
  height: 120px;
  background-image: url("https://xsurface-images.s3.ap-southeast-1.amazonaws.com/no+data.svg");
  background-repeat: no-repeat;
  background-size: 100%;
`;

const ImageNotFound = styled.image`
  width: 120px;
  height: 120px;
  background-image: url("https://xsurface-images.s3.ap-southeast-1.amazonaws.com/not+found.svg");
  background-repeat: no-repeat;
  background-size: 100%;
`;

const TextNoData = styled.pre`
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
`;

const QuoDraftListAdmin = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [quotationDraftList, setQuotationDraftList] = useState([]);

  const [dataSearch, setDataSearch] = useState({
    keyword: null,
    // seller: "",
    page: 0,
    page_size: 10,
  });
  const [rowCount, setRowCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const DesktopColumns = [
    {
      field: "project", // ?
      headerName: "Project",
      flex: 1.5,
      // width: 200,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              outline: "none",
              overflow: "hidden",
              textOverflow: "ellipsis",
              // ...(params?.row?.status !== 0 && {
              //   color: "var(--darkgreen-color)",
              // }),
            }}
          >
            <div style={{ margin: "16px 0", width: "100%" }}>
              <div
                className="MuiDataGrid-cellContent"
                style={{
                  marginBottom: "8px",
                  fontSize: "0.875rem",
                  fontWeight: 500,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {getLocale() === "th" ? "ชื่อ :" : "Name :"}{" "}
                {params.row?.contact?.full_name
                  ? `${params.row?.contact?.full_name}`
                  : `-`}
              </div>
              <div
                className="MuiDataGrid-cellContent"
                style={{
                  marginBottom: "8px",
                  fontSize: "0.875rem",
                  fontWeight: 500,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {getLocale() === "th" ? "เบอร์โทร :" : "Tel :"}{" "}
                {params.row?.contact?.phone_number
                  ? `${params.row?.contact?.phone_number}`
                  : `-`}
              </div>
              <div
                className="MuiDataGrid-cellContent"
                style={{
                  fontSize: "0.875rem",
                  fontWeight: 500,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                Project: {params.row?.project ? `${params.row?.project}` : `-`}
              </div>
            </div>
          </Box>
        );
      },
    },
    {
      field: "sale_code",
      headerName: "Sale Code",
      flex: 1.2,
      // width: 200,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              width: "100%",
              wordWrap: "break-word",
              py: 2,
            }}
          >
            {params?.row?.sale_code ? params?.row?.sale_code : "-"}
          </Box>
        );
      },
    },
    {
      field: "running_number",
      headerName: "Quotation No.",
      flex: 1.5,
      // width: 200,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              width: "100%",
              wordWrap: "break-word",
              py: 2,
            }}
          >
            {params?.row?.running_number}
          </Box>
        );
      },
    },
    {
      field: "createdAt",
      headerName: "Date",
      flex: 1,
      // headerAlign: "center",
      // align: "center",
      editable: false,
      sortable: true,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              width: "100%",
              wordWrap: "break-word",
              py: 2,
            }}
          >
            {params?.row?.createdAt
              ? moment(params?.row?.createdAt).format("DD-MM-YYYY")
              : "-"}
          </Box>
        );
      },
    },
    {
      field: "updatedAt",
      headerName: "Date Update",
      flex: 1,
      // headerAlign: "center",
      // align: "center",
      editable: false,
      sortable: true,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              width: "100%",
              wordWrap: "break-word",
              py: 2,
            }}
          >
            {params?.row?.updatedAt
              ? moment(params?.row?.updatedAt).format("DD-MM-YYYY")
              : "-"}
          </Box>
        );
      },
    },
    {
      field: "status",
      headerName: "PDF My Account",
      flex: 1,
      // width: 200,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              width: "100%",
              wordWrap: "break-word",
              py: 2,
            }}
          >
            {params?.row?.status === 1 ||
            (params?.row?.status === 2 &&
              params?.row?.quotation_pdf_links?.length > 0)
              ? "Request PDF"
              : "-"}
          </Box>
        );
      },
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Action",
      flex: 0.5,
      sortable: false,
      disableColumnMenu: true,
      getActions: (params) => [
        <GridActionsCellItem
          icon={<VisibilityIcon />}
          label="Detail"
          onClick={() => navigate(`/sale-quotation/detail/${params.row._id}`)}
          showInMenu
        />,
      ],
    },
  ];

  const NoRowsOverlay = () => {
    return (
      <Stack height="100%" alignItems="center" justifyContent="center">
        <ImageNoData></ImageNoData>
        <TextNoData>No Data</TextNoData>
      </Stack>
    );
  };

  const NoResultsOverlay = () => {
    return (
      <Stack height="100%" alignItems="center" justifyContent="center">
        <ImageNotFound></ImageNotFound>
        <TextNoData>Not Found</TextNoData>
      </Stack>
    );
  };

  const onSearchButton = () => {
    setDataSearch({ ...dataSearch, page: 0 });
    setIsLoading(true);
    (async () => {
      if (user.role_id === 1) {
        // const { data } = await findAllQuotationList({ ...dataSearch, page: 0 });
        const { data } = await findAllByAdmin({ ...dataSearch, page: 0 });
        setQuotationDraftList(data.rows);
        setRowCount(data.count);
        setIsLoading(false);
      }
    })();
  };

  const handlePageChange = (newPage) => {
    // We have the cursor, we can allow the page transition.
    setDataSearch({ ...dataSearch, page: newPage });
  };

  useEffect(() => {
    setIsLoading(true);
    (async () => {
      if (user.role_id === 1) {
        // const { data } = await findAllQuotationList(dataSearch);
        const { data } = await findAllByAdmin(dataSearch);
        setQuotationDraftList(data.rows);
        setRowCount(data.count);
        setIsLoading(false);
      }
    })();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataSearch.page]);

  return (
    <DivMuiContainer>
      <DivMuiInside>
        <WrapperSearch>
          <TextField
            id="search-input"
            placeholder="ค้นหาจากรหัสเท่านั้น"
            className="TextField-without-border-radius"
            sx={{
              m: 1,
              width: "100%",
              borderRadius: "16px",
            }}
            InputProps={{
              endAdornment: (
                <IconButton
                  id="button-search-quotation"
                  sx={{ padding: 0 }}
                  onClick={() => onSearchButton()}
                >
                  <SearchIcon sx={{ color: "#e04132", cursor: "pointer" }} />
                </IconButton>
              ),
            }}
            onChange={(e) => {
              setDataSearch({ ...dataSearch, keyword: e.target.value });
            }}
            onKeyUp={(e) => (e.code === "Enter" ? onSearchButton() : null)}
          />
        </WrapperSearch>

        {/* next phase (sale agent's role)  */}
        {/* <WrapperSelect>
            <FormControl fullWidth>
              <InputLabel>Sale all</InputLabel>
              <Select
                className="TextField-without-border-radius"
                id="filter-sale"
                label="Sale all"
                onChange={(e) => {
                  setDataSearch({
                    ...dataSearch,
                    seller: e.target.value,
                    page: 0,
                  });
                }}
                value={dataSearch.seller}
              >
                <MenuItem value={""}>
                  Sale all
                </MenuItem>
                <MenuItem value={"office"}>
                  Sale Office
                </MenuItem>
                <MenuItem value={"agent"}>
                  Sale Agent
                </MenuItem>
              </Select>
            </FormControl>
          </WrapperSelect> */}
      </DivMuiInside>

      <WrapperDataGrid>
        <DataGrid
          rows={quotationDraftList}
          getRowId={(row) => row._id}
          getRowHeight={() => "auto"}
          loading={isLoading}
          columns={DesktopColumns}
          pageSize={10}
          rowCount={rowCount}
          paginationMode="server"
          page={dataSearch.page}
          onPageChange={(e) => handlePageChange(e)}
          rowsPerPageOptions={[10]}
          pagination
          disableSelectionOnClick
          components={{
            // Footer: CustomPagination,
            NoRowsOverlay,
            NoResultsOverlay,
          }}
          componentsProps={{
            basePopper: {},
          }}
          sx={{
            "& .MuiDataGrid-actionsCell": {
              transform: "rotate(90deg)",
            },
            ".MuiDataGrid-row": {
              minHeight: {
                xs: "60px !important",
                md: "80px !important",
              },
            },
          }}
        />
      </WrapperDataGrid>
    </DivMuiContainer>
  );
};

export default QuoDraftListAdmin;
